export default __webpack_public_path__ + "static/media/flashingarc6.9138bb8c.png";